import { cacheDom } from '../utils/QuerySelectors.js'
import { toggleModal } from '../components/Popup.js'
import { getProductsByIds } from '../utils/Product.js'
import { trapFocus } from '../utils/helpers.js'
import { GTM_removeFromCartLink } from "../utils/Gtm.js";

const dom = {}
const qs = {
  section: 'data-section-type="main-cart"',
  gifting: 'data-cart-gifting',
  giftMsgWrap: 'data-cart-gift-msg-wrap',
  giftMessage: 'data-cart-gift-msg',
  itemTitle: 'data-cart-item-title',
  itemOptionColor: 'data-cart-option-color',
  itemOptionSize: 'data-cart-option-size',
  itemQty: 'data-cart-item-qty',
  itemPopCancel: 'data-cart-item-pop-cancel',
  itemPopSave: 'data-cart-item-pop-save',
  modal: 'data-popup',
}
const qsAll = {
  itemRemoveLink: 'data-cart-item-remove-link',
  itemEdits: 'data-cart-item-edit',
}
const state = {
  products: [],
  colorOption: null,
  sizeOption: null,
  itemQtySelect: null,
  itemEditBtn: null,
}

const updateSaveButton = () => {
  const product = state.products.filter((product) => product.id == state.colorOption?.value)[0]
  const variant = product.variants.edges.filter((e) => e.node.selectedOptions[1]?.value == state.sizeOption?.value)[0]
    ?.node
  const currentQty = parseInt(state.itemQtySelect?.value) || 1
  const saveBtn = dom.modal.querySelector(`[${qs.itemPopSave}]`)
  const disabled = !variant.availableForSale || variant.quantityAvailable < currentQty
  saveBtn.disabled = disabled
  saveBtn.innerHTML = disabled ? 'Out of stock' : 'Update'
  saveBtn.classList.toggle('button--secondary', disabled)
  saveBtn.classList.toggle('button--primary', !disabled)
}

const updateQtySelect = (rerender = false, variant, currentQty) => {
  const qty = variant.quantityAvailable
  if (rerender) {
    state.itemQtySelect.innerHTML = ''
    for (let i = 1; i <= 10; i++) {
      state.itemQtySelect.innerHTML += `
        <option value="${i}" ${i > qty ? 'disabled' : ''} ${currentQty == i ? 'selected' : ''}>
          ${i}
        </option>
      `
    }
  } else {
    const options = state.itemQtySelect.querySelectorAll('option')
    options.forEach((option, index) => {
      const i = index + 1
      option.disabled = i > qty
      option.selected = i == currentQty
    })
  }
  updateSaveButton()
  state.itemQtySelect.addEventListener('change', () => {
    updateSaveButton()
  })
}

const initModalEvents = (productId, variantId, currentQty, datasetKey) => {
  // console.log('data', state.products)
  const product = state.products.filter((p) => p.id == productId)[0]
  const variant = product.variants.edges.filter((e) => e.node.id == variantId)[0]?.node
  state.colorOption = dom.modal.querySelector(`[${qs.itemOptionColor}]`)
  state.sizeOption = dom.modal.querySelector(`[${qs.itemOptionSize}]`)
  state.itemQtySelect = dom.modal.querySelector(`[${qs.itemQty}]`)
  dom.modal.querySelector(`[${qs.itemTitle}]`).innerHTML = product?.title

  state.products.forEach((p) => {
    const colorOptionData = p.options.filter((option) => option.name == 'Color')[0]
    if (colorOptionData) {
      state.colorOption.innerHTML += `
        <option value="${p.id}" ${product.id == p.id ? 'selected' : ''}>
          ${colorOptionData.name}: ${colorOptionData.optionValues[0]?.name}
        </option>
      `
    }
  })
  updateSizeOptions(product, variant, variant.selectedOptions[1]?.value, currentQty, true)
  state.colorOption.addEventListener('change', () => {
    const productId = state.colorOption.value
    const newProduct = state.products.filter((p) => p.id == productId)[0]
    const newVariant =
      newProduct?.variants.edges.filter((e) => e.node.selectedOptions[1]?.value == state.sizeOption?.value)[0]?.node ||
      variant
    updateSizeOptions(newProduct, newVariant, state.sizeOption?.value, state.itemQtySelect?.value, false)
  })

  dom.modal.querySelector(`[${qs.itemPopCancel}]`).addEventListener('click', () => {
    toggleModal(false)
  })

  const saveBtn = dom.modal.querySelector(`[${qs.itemPopSave}]`)
  saveBtn.addEventListener('click', () => {
    const variantId = state.itemEditBtn?.dataset?.variantId
    const apiVariantId = `gid://shopify/ProductVariant/${variantId}`
    const product = state.products.filter((product) => product.id == state.colorOption?.value)[0]
    const variant = product.variants.edges.filter((e) => e.node.selectedOptions[1]?.value == state.sizeOption?.value)[0]
      ?.node
    const currentQty = parseInt(state.itemQtySelect?.value) || 1
    saveBtn.disabled = true
    if (variant.id == apiVariantId) {
      window.changeLineItem(
        () => {
          location.reload()
        },
        {
          quantity: currentQty,
          id: state.itemEditBtn.dataset.key,
        },
        {
          type: 'update_variant',
          product: product,
          variant: variant,
          prevQuantity: state.itemEditBtn?.dataset?.qty,
        }
      )
    } else {
      window.changeLineItem(
        () => {
          window.addLineItems(() => {
            location.reload()
          }, [
            {
              id: variant?.id.replace('gid://shopify/ProductVariant/', ''),
              quantity: currentQty,
            },
          ])
        },
        {
          quantity: 0,
          id: state.itemEditBtn.dataset.key,
        },
        {
          type: 'new_variant',
          product: product,
          variant: variant,
          prevQuantity: state.itemEditBtn?.dataset?.qty,
        }
      )
    }
  })
}

const updateSizeOptions = (product, variant, sizeOptionValue, currentQty, qtyRerender) => {
  const sizeOptionData = product.options.filter((option) => option.name == 'Size')[0]
  state.sizeOption.innerHTML = ''
  sizeOptionData.optionValues.forEach((value) => {
    state.sizeOption.innerHTML += `<option value="${value.name}" ${sizeOptionValue == value.name ? 'selected' : ''}>Size: ${value.name}</option>`
  })
  updateQtySelect(qtyRerender, variant, currentQty)

  state.sizeOption.addEventListener('change', () => {
    const newVariant = product.variants.edges.filter(
      (e) => e.node.selectedOptions[1]?.value == state.sizeOption?.value,
    )[0]?.node
    updateQtySelect(false, newVariant, state.itemQtySelect?.value)
  })
}

export const setupCart = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    const section = dom.section.closest('.shopify-section')
    section.classList.add('shopify-cart-section')
    if (dom.section.classList.contains('has-items')) section.classList.add('has-cart-items')
    if (dom.gifting) {
      dom.gifting.addEventListener('input', () => {
        dom.giftMsgWrap.classList.toggle('!hidden', !dom.gifting.checked)
        window.updateAdditional(null, {
          attributes: {
            include_gift_message: dom.gifting.checked ? 'true' : null,
            gift_message: dom.gifting.checked ? dom.giftMessage.value?.trim() : null,
          },
        })
      })

      dom.giftMessage.addEventListener('change', () => {
        window.updateAdditional(null, {
          attributes: {
            gift_message: dom.giftMessage.value?.trim(),
          },
        })
      })
    }

    dom.itemEdits.forEach((itemEdit) => {
      itemEdit.addEventListener('click', () => {
        state.itemEditBtn = itemEdit
        getProductsByIds(
          (products) => {
            state.products = products
            const productId = `gid://shopify/Product/${itemEdit.dataset.productId}`
            const variantId = `gid://shopify/ProductVariant/${itemEdit.dataset.variantId}`
            const quantity = parseInt(itemEdit.dataset.qty)
            window.openPopup(document.querySelector('#cartItemEditPopup').innerHTML, null, itemEdit)
            initModalEvents(productId, variantId, quantity, itemEdit.dataset.key)
            setTimeout(() => {
              trapFocus(document.querySelector('[data-popup-close]'), document.querySelector(`[${qs.itemPopSave}]`))
            }, 50)
          },
          itemEdit.dataset.ids.split(',').map((id) => `"gid://shopify/Product/${id}"`),
        )
      })
    })

    dom.itemRemoveLink.forEach((itemRemoveLink) => {
      itemRemoveLink.addEventListener('click', (e) => {
        e.preventDefault();
        const item = JSON.parse(e.target.dataset.item),
        link = e.target;
        GTM_removeFromCartLink(item);
        setTimeout(() => {
          window.location.href = link.href;
        }, 500);
      })
    })
  }
}
